import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import colors from 'vuetify/es5/util/colors';


Vue.use(Vuetify)

export default new Vuetify({
    theme: {
        options: { customProperties: true },
        themes: {
          light: {
            primary: {
              base: '#303361',
              darken2: '#313361',
              darken4: '#303146',
              lighten4: '#F7F7FF',
            },
            secondary: '#178386',
            accent: colors.grey,
            error: colors.red,
            warning: colors.amber,
            info: colors.lightBlue,
            success: colors.lightGreen,
          },
          dark: {
            primary: '#3767A2',
            secondary: '#178386',
            accent: colors.grey,
            error: colors.red,
            warning: colors.amber,
            info: colors.lightBlue,
            success: colors.lightGreen,
          },
        },
      },
})
